export function groupEventsByDay(events) {
    var groups = new Map();
    events.forEach(function (event) {
        var _a;
        var dayKey = event.date.slice(0, 10);
        var dayEvents = (_a = groups.get(dayKey)) !== null && _a !== void 0 ? _a : [];
        dayEvents.push(event);
        groups.set(dayKey, dayEvents);
    });
    return Array.from(groups.entries())
        .sort(function (_a, _b) {
        var a = _a[0];
        var b = _b[0];
        return a.localeCompare(b);
    })
        .map(function (_a) {
        var dayKey = _a[0], dayEvents = _a[1];
        return ({
            dayKey: dayKey,
            date: new Date(dayEvents[0].date),
            events: dayEvents,
        });
    });
}
